import React from 'react'
import styled from 'styled-components'
import Email from './Email'
import Twitter from './Twitter'
import Facebook from './Facebook'
import Messenger from './Messenger'

const Container = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  max-width: 260px;
  margin: 0 auto;
`

const url = process.env.REACT_APP_SHARE_URL || 'https://planswell.com/child-affordability-calculator/'
const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID

export default (props) => (
  <Container>
    <Email url={url} {...props} />
    <Twitter url={url} {...props} />
    <Facebook url={url} facebookAppId={facebookAppId} {...props} />
    <Messenger url={url} facebookAppId={facebookAppId} {...props} />
  </Container>
)
